import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p427216140118241280',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
